import HttpClientRepository, { httpClientRepository } from './HttpClient.repository';

export class HttpClientFactory {
    private static rgsClientInstance: HttpClientRepository;

    public static getIframeClient() {
        return httpClientRepository;
    }

    public static getRgsClient() {
        if (!this.rgsClientInstance) {
            this.rgsClientInstance = new HttpClientRepository();
            this.rgsClientInstance.removeHeader('Client');
            this.rgsClientInstance.removeHeader('Client-Version');
            this.rgsClientInstance.apiUrl = '';
        }

        return this.rgsClientInstance;
    }
}
